// extracted by mini-css-extract-plugin
export default {"About":"About_About__GzrlA","AboutTitle":"About_AboutTitle__c0MDv","JewelleryBtn":"About_JewelleryBtn__niC9l","AboutDesc":"About_AboutDesc__tcfXD"};